import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// constants
import { WithDrawActionTypes } from "./constants";
import { getWithdrawData, WithdrawApiResponseSuccess, WithdrawApiResponseError } from "./actions";
import { getWithdrawsData, updateWithdrawStatus } from "../../helpers/api/withdraws";
import { MAX_ITEMS_PER_PAGE } from "../../helpers/api/apiCore";

function* getUsersDatas({ payload: { status, page, limit } }: any): SagaIterator {
  try {
    const response = yield call(getWithdrawsData, { status, page, limit });
    const data = response?.data?.data;

    yield put(WithdrawApiResponseSuccess(WithDrawActionTypes.GET_DATA, data));
  } catch (error: any) {
    yield put(WithdrawApiResponseError(WithDrawActionTypes.GET_DATA, error));
  }
}

function* updateWithdrawsSaga({ payload: { id, status } }: any): SagaIterator {
  try {
    const response = yield call(updateWithdrawStatus, { id, status });
    const message = response?.data?.message;

    yield put(WithdrawApiResponseSuccess(WithDrawActionTypes.WITHDRAW_STATUS, message));
    yield put(getWithdrawData("all", 1, MAX_ITEMS_PER_PAGE));
  } catch (error: any) {
    yield put(WithdrawApiResponseError(WithDrawActionTypes.WITHDRAW_STATUS, error));
  }
}

export function* watchGetWithdraws() {
  yield takeEvery(WithDrawActionTypes.GET_DATA, getUsersDatas);
}

export function* watchUpdateWithdraws() {
  yield takeEvery(WithDrawActionTypes.WITHDRAW_STATUS, updateWithdrawsSaga);
}

function* WithdrawSaga() {
  yield all([fork(watchGetWithdraws), fork(watchUpdateWithdraws)]);
}

export default WithdrawSaga;
